import React from 'react';
import { Link } from 'react-router-dom';
import InstallButton from '../common/InstallButton';
import '../styles/footer.css';

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="footer-brand">
        <img src="/images/JyotishSastra_Icon.svg" alt="JyotishSastra" className="footer-logo" />
        <span className="footer-brand-name">JyotishSastra</span>
      </div>
      <div className="footer-tagline">Vedic Astrology Platform</div>
      <div className="footer-divider" />
      <div className="social-links">
        <a href="#" className="social-icon">📱</a>
        <a href="#" className="social-icon">📸</a>
        <a href="#" className="social-icon">💼</a>
        <a href="#" className="social-icon">📺</a>
      </div>
      <div className="app-links">
        <InstallButton className="app-link" />
      </div>
      <div className="footer-legal">
        <Link to="/privacy">Privacy Policy</Link>
        <span className="footer-legal-divider">&middot;</span>
        <Link to="/terms">Terms of Service</Link>
      </div>
      <div className="footer-unit">
        A unit of Bharath Ancient Sciences and Solutions
      </div>
      <div className="copyright">
        Copyright &copy; 2025 JyotishSastra. All Rights Reserved &middot; jyotishsastra.com
      </div>
    </footer>
  );
};

export default Footer;
